import React, { useState, useRef } from "react";

const students = [
  {
    id: 1,
    name: "Rahul Sharma",
    roll: "101",
    class: "10th",
    section: "A",
    dob: "12-Mar-2010",
    gender: "Male",
    fatherName: "Suresh Sharma",
    motherName: "Sunita Sharma",
    attendance: { present: 192, total: 200 },
    photo: "https://via.placeholder.com/100x120?text=Photo",
    examMarks: {
      "Unit Test 1":    { Telugu:18, Hindi:17, English:19, Mathematics:20, Science:18, Social:17 },
      "Unit Test 2":    { Telugu:17, Hindi:18, English:18, Mathematics:19, Science:20, Social:16 },
      "Quarterly Exam": { Telugu:70, Hindi:72, English:78, Mathematics:85, Science:80, Social:68 },
      "Half Yearly":    { Telugu:74, Hindi:76, English:80, Mathematics:88, Science:83, Social:71 },
      "Final Exam":     { Telugu:88, Hindi:90, English:92, Mathematics:95, Science:91, Social:86 },
    },
    examMaxMarks: {
      "Unit Test 1":    20,
      "Unit Test 2":    20,
      "Quarterly Exam": 100,
      "Half Yearly":    100,
      "Final Exam":     100,
    },
  },
  {
    id: 2,
    name: "Vignika",
    roll: "102",
    class: "10th",
    section: "A",
    dob: "05-Jul-2010",
    gender: "Female",
    fatherName: "Ravi Kumar",
    motherName: "Padma Kumar",
    attendance: { present: 188, total: 200 },
    photo: "https://via.placeholder.com/100x120?text=Photo",
    examMarks: {
      "Unit Test 1":    { Telugu:15, Hindi:16, English:17, Mathematics:18, Science:16, Social:15 },
      "Unit Test 2":    { Telugu:16, Hindi:15, English:17, Mathematics:17, Science:18, Social:16 },
      "Quarterly Exam": { Telugu:62, Hindi:65, English:70, Mathematics:74, Science:68, Social:60 },
      "Half Yearly":    { Telugu:65, Hindi:67, English:72, Mathematics:78, Science:70, Social:63 },
      "Final Exam":     { Telugu:78, Hindi:80, English:85, Mathematics:88, Science:82, Social:79 },
    },
    examMaxMarks: {
      "Unit Test 1":    20,
      "Unit Test 2":    20,
      "Quarterly Exam": 100,
      "Half Yearly":    100,
      "Final Exam":     100,
    },
  },
];

const SUBJECTS = ["Telugu", "Hindi", "English", "Mathematics", "Science", "Social"];
const EXAMS = ["Unit Test 1", "Unit Test 2", "Quarterly Exam", "Half Yearly", "Final Exam"];

const schoolDetails = {
  name: "ABC Public School",
  tagline: "Nurturing Minds, Building Futures",
  address: "MG Road, Vijayawada, Andhra Pradesh – 520010",
  phone: "+91 98765 43210",
  email: "abcschool@gmail.com",
  affiliation: "Affiliated to CBSE | School Code: 123456",
  logo: "https://via.placeholder.com/80x80?text=LOGO",
};

const getGrade = (pct) => {
  if (pct >= 90) return { grade: "A+", color: "#1a7a4a" };
  if (pct >= 80) return { grade: "A",  color: "#2e7d32" };
  if (pct >= 70) return { grade: "B",  color: "#1565c0" };
  if (pct >= 60) return { grade: "C",  color: "#e65100" };
  if (pct >= 40) return { grade: "D",  color: "#6a1b9a" };
  return             { grade: "F",  color: "#c62828" };
};

const subjectGrade = (marks, max) => getGrade((marks / max) * 100);

export default function ReportCards() {
  const [filters, setFilters] = useState({
    year: "2025-26",
    exam: "Final Exam",
    curriculum: "CBSE",
    className: "10th",
    section: "A",
    studentId: "",
  });
  const [student, setStudent] = useState(null);
  const [remarks, setRemarks] = useState({ teacher: "", principal: "" });
  const printRef = useRef();

  const handleFilter = (key, val) => setFilters((f) => ({ ...f, [key]: val }));

  const loadStudent = (id) => {
    if (!id) { setStudent(null); return; }
    setStudent(students.find((s) => s.id === Number(id)) || null);
    setRemarks({ teacher: "", principal: "" });
  };

  const getExamData = (exam) => {
    if (!student) return null;
    const marks = student.examMarks[exam];
    const max = student.examMaxMarks[exam];
    const total = SUBJECTS.reduce((s, sub) => s + marks[sub], 0);
    const totalMax = SUBJECTS.length * max;
    const pct = (total / totalMax) * 100;
    return { marks, max, total, totalMax, pct };
  };

  const getFinalResult = () => {
    const data = getExamData(filters.exam);
    if (!data) return null;
    const { total, totalMax, pct } = data;
    const { grade } = getGrade(pct);
    return { total, totalMax, pct: pct.toFixed(2), grade, pass: pct >= 40 };
  };

  const handlePrint = () => {
    window.print();
  };

  const result = student ? getFinalResult() : null;
  const examData = student ? getExamData(filters.exam) : null;
  const attendancePct = student
    ? ((student.attendance.present / student.attendance.total) * 100).toFixed(1)
    : 0;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700;900&family=Inter:wght@400;500;600&display=swap');

        body { background: #f0f4f8; }

        .rc-page { font-family: 'Inter', sans-serif; }

        .rc-header-bar {
          background: linear-gradient(135deg, #1a237e 0%, #283593 60%, #3949ab 100%);
          color: #fff;
          border-radius: 12px 12px 0 0;
          padding: 0;
        }
        .rc-school-name {
          font-family: 'Merriweather', serif;
          font-size: 1.55rem;
          font-weight: 900;
          letter-spacing: 0.5px;
          line-height: 1.2;
        }
        .rc-tagline {
          font-size: 0.78rem;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          opacity: 0.82;
        }
        .rc-affil {
          font-size: 0.72rem;
          opacity: 0.7;
          letter-spacing: 0.4px;
        }

        .rc-title-band {
           background: #03A9F4;
            color: #ffffff;
          font-family: 'Merriweather', serif;
          font-weight: 700;
          font-size: 1rem;
          letter-spacing: 2px;
          text-align: center;
          padding: 7px 0;
          text-transform: uppercase;
          border-bottom: 3px solid #1a237e;
        }

        .rc-filter-card {
          border: none;
          border-radius: 10px;
          box-shadow: 0 2px 12px rgba(26,35,126,0.09);
        }
        .rc-filter-card .card-header {
        //   background: #283593;
        //   color: #fff;
          border-radius: 10px 10px 0 0;
          font-weight: 600;
          font-size: 0.92rem;
        }

        .rc-card {
          border: none;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(26,35,126,0.12);
          overflow: hidden;
        }

        .rc-student-photo {
          width: 90px; height: 110px;
          object-fit: cover;
          border: 3px solid #1a237e;
          border-radius: 6px;
        }

        .rc-info-label {
          font-size: 0.72rem;
          text-transform: uppercase;
          color: #888;
          letter-spacing: 0.6px;
          margin-bottom: 1px;
        }
        .rc-info-val {
          font-size: 0.9rem;
          font-weight: 600;
          color: #1a237e;
        }

        .rc-marks-table thead th {
          background: #1a237e;
          color: #fff;
          font-size: 0.78rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
          vertical-align: middle;
          text-align: center;
        }
        .rc-marks-table tbody td {
          vertical-align: middle;
          font-size: 0.85rem;
          text-align: center;
        }
        .rc-marks-table tbody td:first-child {
          text-align: left;
          font-weight: 600;
          color: #283593;
        }
        .rc-marks-table tbody tr:hover { background: #e8eaf6; }

        .rc-stat-box {
          border-radius: 10px;
          padding: 14px 10px;
          text-align: center;
          border: 2px solid transparent;
        }
        .rc-stat-box .rc-stat-label {
          font-size: 0.7rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #666;
          margin-bottom: 4px;
        }
        .rc-stat-box .rc-stat-val {
          font-family: 'Merriweather', serif;
          font-size: 1.45rem;
          font-weight: 700;
          line-height: 1;
        }

        .rc-sig-line {
          border-top: 1.5px solid #444;
          margin-top: 32px;
          padding-top: 4px;
          font-size: 0.75rem;
          color: #666;
          text-align: center;
        }

        .rc-attend-bar {
          height: 8px;
          border-radius: 4px;
          background: #e0e0e0;
          overflow: hidden;
        }
        .rc-attend-fill {
          height: 100%;
          border-radius: 4px;
          background: linear-gradient(90deg, #1a237e, #42a5f5);
          transition: width 0.6s ease;
        }

        @media print {
          body * { visibility: hidden; }
          #rc-printable, #rc-printable * { visibility: visible; }
          #rc-printable { position: absolute; left: 0; top: 0; width: 100%; }
          .no-print { display: none !important; }
          .rc-card { box-shadow: none !important; }
        }
      `}</style>

      <div className="rc-page py-0">

        {/* PAGE TITLE */}
        <div className="d-flex align-items-center mb-2 gap-2 no-print">
          <div>
            <h4 className="mb-0 fw-bold text-primary">Student Report Cards</h4>
            <small className="text-muted">Academic Year {filters.year}</small>
          </div>
        </div>

        {/* FILTERS */}
        <div className="card rc-filter-card mb-4 no-print">
          <div className="card-header d-inline">
            <i className="bi bi-funnel-fill me-3"></i>  Report Card Filters
          </div>
          <div className="card-body pb-3">
            <div className="row g-3">
              {[
                { label: "Academic Year", key: "year", opts: ["2025-26", "2024-25"] },
                { label: "Curriculum",    key: "curriculum", opts: ["CBSE", "State Board"] },
                { label: "Class",         key: "className", opts: ["10th", "9th", "8th"] },
                { label: "Section",       key: "section", opts: ["A", "B", "C"] },
              ].map(({ label, key, opts }) => (
                <div className="col-md-2 col-6" key={key}>
                  <label className="form-label fw-semibold" style={{ fontSize: "0.8rem" }}>{label}</label>
                  <select className="form-select form-select-sm" value={filters[key]}
                    onChange={(e) => handleFilter(key, e.target.value)}>
                    {opts.map((o) => <option key={o}>{o}</option>)}
                  </select>
                </div>
              ))}

              <div className="col-md-2 col-6">
                <label className="form-label fw-semibold" style={{ fontSize: "0.8rem" }}>Exam</label>
                <select className="form-select form-select-sm" value={filters.exam}
                  onChange={(e) => handleFilter("exam", e.target.value)}>
                  {EXAMS.map((e) => <option key={e}>{e}</option>)}
                </select>
              </div>

              <div className="col-md-2 col-12">
                <label className="form-label fw-semibold" style={{ fontSize: "0.8rem" }}>Student</label>
                <select className="form-select form-select-sm"
                  onChange={(e) => loadStudent(e.target.value)}>
                  <option value="">— Select Student —</option>
                  {students.map((s) => (
                    <option key={s.id} value={s.id}>{s.name} ({s.roll})</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* PLACEHOLDER */}
        {!student && (
          <div className="text-center py-5 text-muted no-print">
            <i className="bi bi-person-bounding-box" style={{ fontSize: "3rem", color: "#c5cae9" }}></i>
            <p className="mt-2">Select a student to generate the report card</p>
          </div>
        )}

        {/* REPORT CARD */}
        {student && examData && result && (
          <div id="rc-printable" ref={printRef}>
            <div className="rc-card">

              {/* SCHOOL HEADER */}
              <div className="rc-header-bar p-3">
                <div className="d-flex align-items-center gap-3">
                  <img src={schoolDetails.logo} alt="Logo"
                    style={{ width: 70, height: 70, borderRadius: 8, border: "2px solid rgba(255,255,255,0.4)", background: "#fff", objectFit: "contain" }} />
                  <div className="flex-grow-1 text-center">
                    <div className="rc-school-name">{schoolDetails.name}</div>
                    <div className="rc-tagline mt-1">{schoolDetails.tagline}</div>
                    <div className="rc-affil mt-1">{schoolDetails.affiliation}</div>
                  </div>
                  <div className="text-end d-none d-md-block" style={{ fontSize: "0.75rem", opacity: 0.85, minWidth: 170 }}>
                    <div><i className="bi bi-geo-alt-fill me-1"></i>{schoolDetails.address}</div>
                    <div className="mt-1"><i className="bi bi-telephone-fill me-1"></i>{schoolDetails.phone}</div>
                    <div><i className="bi bi-envelope-fill me-1"></i>{schoolDetails.email}</div>
                  </div>
                </div>
              </div>

              {/* REPORT CARD TITLE BAND */}
              <div className="rc-title-band">
                 Progress Report Card — {filters.exam} | Academic Year: {filters.year}
              </div>

              <div className="card-body p-3 p-md-4 bg-white">

                {/* STUDENT INFO */}
                <div className="row align-items-start mb-2 g-3">
                  <div className="col-auto">
                    <img src={student.photo} alt="Student" className="rc-student-photo" />
                  </div>
                  <div className="col">
                    <h5 className="fw-bold mb-2" style={{ color: "#1a237e", fontFamily: "Merriweather, serif" }}>
                      {student.name}
                    </h5>
                    <div className="row g-2">
                      {[
                        ["Roll No.", student.roll],
                        ["Class & Section", `${student.class} – ${student.section}`],
                        ["Date of Birth", student.dob],
                        ["Gender", student.gender],
                        ["Father's Name", student.fatherName],
                        ["Mother's Name", student.motherName],
                      ].map(([label, val]) => (
                        <div className="col-6 col-md-4" key={label}>
                          <span className="rc-info-label">{label}: </span>
                          <span className="rc-info-val">{val}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* <hr style={{ borderColor: "#c5cae9", borderWidth: 2 }} /> */}

                {/* MARKS TABLE */}
                {/* <h6 className="fw-bold mb-3" style={{ color: "#1a237e", letterSpacing: 0.5 }}>
                   Subject-wise Marks
                </h6> */}

                <div className="table-responsive mb-4">
                  <table className="table table-bordered table-striped rc-marks-table mb-0">
                    <thead>
                      <tr>
                        <th style={{ minWidth: 120, textAlign: "left" }}>Subject</th>
                        {EXAMS.map((ex) => (
                          <th key={ex} style={{ minWidth: 68 }}>
                            {ex}<br />
                            <span style={{ fontWeight: 400, fontSize: "0.68rem", opacity: 0.8 }}>
                              /{student.examMaxMarks[ex]}
                            </span>
                          </th>
                        ))}
                        <th style={{ background: "#283593" }}>Total<br /><span style={{ fontWeight: 400, fontSize: "0.68rem" }}>/500</span></th>
                        <th style={{ background: "#283593" }}>%</th>
                        <th style={{ background: "#283593" }}>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {SUBJECTS.map((sub) => {
                        const subTotal = EXAMS.reduce((acc, ex) => acc + student.examMarks[ex][sub], 0);
                        const subMax = EXAMS.reduce((acc, ex) => acc + student.examMaxMarks[ex], 0);
                        const subPct = (subTotal / subMax) * 100;
                        const { grade, color } = getGrade(subPct);
                        return (
                          <tr key={sub}>
                            <td>{sub}</td>
                            {EXAMS.map((ex) => (
                              <td key={ex}>{student.examMarks[ex][sub]}</td>
                            ))}
                            <td><strong>{subTotal}</strong></td>
                            <td>{subPct.toFixed(1)}%</td>
                            <td><span className="badge" style={{ background: color, fontSize: "0.8rem", minWidth: 32 }}>{grade}</span></td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr style={{ background: "#e8eaf6", fontWeight: 700 }}>
                        <td style={{  color: "#1a237e" }}>Grand Total</td>
                        {EXAMS.map((ex) => {
                          const exTotal = SUBJECTS.reduce((a, s) => a + student.examMarks[ex][s], 0);
                          return <td key={ex}>{exTotal}</td>;
                        })}
                        <td style={{ color: "#1a237e" }}>{EXAMS.reduce((a, ex) => a + SUBJECTS.reduce((b, s) => b + student.examMarks[ex][s], 0), 0)}</td>
                        <td colSpan={2}></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* RESULT SUMMARY */}
                <h6 className="fw-bold mb-3" style={{ color: "#1a237e" }}>
                  <i className="bi bi-bar-chart-fill me-2"></i>
                  {filters.exam} — Result Summary
                </h6>

                <div className="row g-3 mb-4">
                  {[
                    { label: "Total Marks",  val: `${examData.total} / ${examData.totalMax}`, bg: "#e8eaf6", border: "#3949ab", color: "#1a237e" },
                    { label: "Percentage",   val: `${result.pct}%`,                           bg: "#e8f5e9", border: "#43a047", color: "#2e7d32" },
                    { label: "Grade",        val: result.grade,                               bg: "#fff8e1", border: "#f9a825", color: "#e65100" },
                    { label: "Result",       val: result.pass ? "PASS" : "FAIL",              bg: result.pass ? "#e8f5e9" : "#ffebee", border: result.pass ? "#43a047" : "#e53935", color: result.pass ? "#1b5e20" : "#b71c1c" },
                  ].map(({ label, val, bg, border, color }) => (
                    <div className="col-6 col-md-3" key={label}>
                      <div className="rc-stat-box" style={{ background: bg, borderColor: border }}>
                        <div className="rc-stat-label">{label}</div>
                        <div className="rc-stat-val" style={{ color }}>{val}</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* ATTENDANCE */}
                <div className="mb-4 p-3 rounded" style={{ background: "#f3f4fb", border: "1.5px solid #c5cae9" }}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="fw-semibold" style={{ color: "#1a237e", fontSize: "0.88rem" }}>
                      <i className="bi bi-calendar-check-fill me-2"></i>Attendance
                    </span>
                    <span className="fw-bold" style={{ color: Number(attendancePct) >= 75 ? "#2e7d32" : "#c62828" }}>
                      {student.attendance.present} / {student.attendance.total} days &nbsp;({attendancePct}%)
                    </span>
                  </div>
                  <div className="rc-attend-bar">
                    <div className="rc-attend-fill" style={{ width: `${attendancePct}%` }}></div>
                  </div>
                  {Number(attendancePct) < 75 && (
                    <small className="text-danger mt-1 d-block">
                      <i className="bi bi-exclamation-triangle-fill me-1"></i>
                      Attendance below 75% — may affect eligibility
                    </small>
                  )}
                </div>

                {/* REMARKS */}
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold" style={{ color: "#283593", fontSize: "0.85rem" }}>
                      <i className="bi bi-pencil-square me-1"></i>Class Teacher's Remarks
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="Enter class teacher's remarks…"
                      value={remarks.teacher}
                      onChange={(e) => setRemarks((r) => ({ ...r, teacher: e.target.value }))}
                      style={{ borderColor: "#9fa8da", fontSize: "0.87rem" }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold" style={{ color: "#283593", fontSize: "0.85rem" }}>
                      <i className="bi bi-person-badge-fill me-1"></i>Principal's Remarks
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      placeholder="Enter principal's remarks…"
                      value={remarks.principal}
                      onChange={(e) => setRemarks((r) => ({ ...r, principal: e.target.value }))}
                      style={{ borderColor: "#9fa8da", fontSize: "0.87rem" }}
                    />
                  </div>
                </div>

                {/* SIGNATURES */}
                <div className="row mt-2 mb-2">
                  {["Class Teacher", "Examinations In-Charge", "Principal", "Parent / Guardian"].map((sig) => (
                    <div className="col-6 col-md-3" key={sig}>
                      <div className="rc-sig-line">{sig}</div>
                    </div>
                  ))}
                </div>

                <hr style={{ borderColor: "#c5cae9" }} />

                {/* ACTIONS */}
                <div className="d-flex justify-content-end gap-2 mt-3 no-print">
                  <button className="btn btn-outline-primary btn-sm" onClick={handlePrint}>
                    <i className="bi bi-printer-fill me-2"></i>Print Report Card
                  </button>
                </div>

              </div>{/* card-body */}
            </div>{/* rc-card */}
          </div>
        )}

      </div>
    </>
  );
}